export const returnMethod = Object.freeze({
  key: 'key',
  object: 'object',
});

export const findSelectedMethod = ({ list, returnType = returnMethod.key, selectedKey }) => {
  let filtered = [];
  if (selectedKey) {
    filtered = list && list.filter(item => item.key === selectedKey);
  } else {
    filtered = list && list.filter(item => item.isSelected);
  }
  if (returnType === returnMethod.object) {
    return filtered.length > 0 ? filtered[0] : {};
  }
  return filtered.length > 0 ? filtered[0].key : '';
};

export const convertAddressToBackend = (address, fullName) => {
  if (!address) {
    return {
      fullName,
    };
  }
  return {
    fullName,
    line1: address.line1 || address.street,
    line2: address.line2 || address.apartmentUnit,
    city: address.city,
    region: address.region || address.state,
    regionDescription: address.regionDescription || address.stateLong,
    postal: address.postal || address.zip,
    countryIso2: address.countryIso2,
    userInputSingleLine: address.userInputSingleLine,
  };
};

export const parseTypeAsText = (type, label) => {
  if (!label.includes('.' || '_')) {
    return label;
  }
  if (!type.includes('.' || '_')) {
    return type;
  }
  return '';
};

export const areRequiredFieldsReady = (fullName, address, methods, selectedMethodKey) => {
  const c1 = [fullName, address].every(Boolean);
  const c2 = methods.length > 0 && !!selectedMethodKey;
  return c1 && c2;
};
